import { HorarioModel } from "../horario/horario-model";
import { ProdutoEntregaModel } from "../produto/produto-entrega-model";

export class ConfigDeliveryModel {
    constructor(
        public deliveryHabilitado: boolean = false,
        public produtoEntrega: ProdutoEntregaModel | null = null,
        public horarioFuncionamento: HorarioModel = new HorarioModel(),
    ) { }
}